import {
  FragmentViewNavigationState,
  routeGenerator,
} from '@app/modules/fragments/routing/FragmentsRoutes';
import { webApi } from '@mi-front/api-clients';

/**
 * Builds the navigation target used by fragment cards so route and route state
 * stay consistent across all card variants.
 */
export function buildFragmentNavigationParams(fragment: webApi.FragmentListItemDto) {
  return {
    pathname: routeGenerator.view(fragment.id),
    state: { fragment } satisfies FragmentViewNavigationState,
  };
}
